<template lang="html">

  <div class="header-wrapper" :style="style.colorDarkBlack">

    <section class="header row-between" :min="isMin">

      <span class="fake-bg" :oferta="$route.meta.isOferta"></span>

      <div class="contenedor-logo row-start">

        <router-link class="logo row-start" to="/">
          <img :src="logoselected" alt="Logo" :size="logosize">
        </router-link>

      </div>

      <div class="contenedor-texto row-end" v-if="logged">

        <router-link v-if="!!personales & isAlumno" class="nombre" to="/cv">Hola, {{personales}}</router-link>
        <router-link v-if="!!personales & isEmpresa" class="nombre" to="/mi-perfil">Hola, {{personales}}</router-link>

        <notificaciones></notificaciones>

        <button class="show-menu" @click="showMenu= true" :style="ownstyles.colorMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>

      </div>

    </section>

    <section class="menu row-center" :show="showMenu">

      <div class="left row-center">
        <span class="logo-menu-container" @click="hideMenu">
          <router-link to="/">
            <img :src="logo" alt="Logo" class="logo-menu" :size="logosize"></router-link>
        </span>
      </div>

      <div class="right row-center" :style="style.backgroundWhite">

        <button class="cerrar-menu" @click="showMenu= false">✕</button>

        <nav>

          <div class="mains">

            <span @click="hideMenu">
              <router-link to="/" class="logo-movil">
                <img :src="logocolor" alt="Logo" :size="logosize">
              </router-link>
            </span>

            <template v-if="isAlumno">
              <template v-if="isEstudiante">
                <span class="main">Prácticas estudiantes ULE  <button v-if="isEstudiante && isTitulado" class="fa fa-angle-down" aria-hidden="true" @click="openPanelEstudiante = !openPanelEstudiante" :open="openPanelEstudiante"></button></span>
                <template v-if="openPanelEstudiante">
                  <template v-if="!!ofertasParams.practicas.numTotal">
                    <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.ofertas_practicas')" class="submenu">Buscar ofertas prácticas estudiantes</router-link>
                  </template>
                  <!-- <template v-if="hasPracticas && showPropuestaPracticas ">
                    <router-link @click.native="hideMenu" class="submenu" :style="style.fontSecondary" :to="$t('enlaces.propuesta_practicas')">Propuesta
                      de prácticas</router-link>
                  </template> -->
                  <router-link  @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_candidaturas_estudiantes')" class="submenu">Mis
                    candidaturas</router-link>
                  <router-link  @click.native="hideMenu" :style="style.fontSecondary" v-if="hasPracticas" class="submenu" :to="$t('enlaces.mis_practicas_estudiante')">Mis prácticas </router-link>
                </template>
              </template>
              <template v-if="isTitulado">
                <span class="main">Prácticas titulados <button v-if="isEstudiante && isTitulado" class="fa fa-angle-down" aria-hidden="true" @click="openPanelTitulado = !openPanelTitulado" :open="openPanelTitulado"></button></span>
                <template v-if="openPanelTitulado">
                  <template >
                    <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.ofertas_practicas_titulados')" class="submenu">Buscar ofertas prácticas titulados</router-link>
                  </template>
                  <router-link  @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_candidaturas_titulados')" class="submenu">Mis
                    candidaturas</router-link>
                  <router-link  @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_practicas')"
                  class="submenu">Mis prácticas</router-link>
                  <template v-if="brand.hasProgramaPracticasActivo">
                    <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.programapracticasactivos')" class="submenu">Programas de prácticas
                    </router-link>
                  </template>
                </template>
                <span class="main">Empleo <button v-if="isEstudiante && isTitulado" class="fa fa-angle-down" aria-hidden="true" @click="openPanelEmpleo = !openPanelEmpleo" :open="openPanelEmpleo"></button></span>
                <template v-if="openPanelEmpleo">
                  <template v-if="!!ofertasParams.empleo.numTotal">
                    <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.ofertas_empleo')" class="submenu">Buscar ofertas
                      de empleo</router-link>
                  </template>
                  <router-link  @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_candidaturas_empleo')" class="submenu">Mis
                    candidaturas</router-link>
                  </template>
              </template>
             
              <!-- <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/#encuestas" class="main">Encuestas pendientes
              </router-link> -->

              <router-link v-if="brand.hasEventos" @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.eventos')" class="main">Eventos</router-link>


              <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.cv')" class="main">Mi CV</router-link>
              
              <router-link v-if="brand.hasGuiasOrientacion" @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.guiaOrientacion')" class="main">Guías Orientación</router-link>
              

            </template>

            <template v-if="false">

              <!-- OCULTAMOS DE MOMENTO EN PROD -->
              <!-- <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_ofertas')" class="main">Mis ofertas
              </router-link> -->
              <!-- FORZAMOS A QUE VAYA A P.ESTUDIANTES EN PROD -->
              <span  :style="style.fontSecondary" class="main">Mis ofertas
              </span>
              <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/mis-ofertas/practicas" class="submenu">Mis ofertas estudiantes
              </router-link>
              <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/mis-ofertas/practicastitulados" class="submenu">Mis ofertas titulados
              </router-link>
              <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/mis-ofertas/empleo" class="submenu">Mis ofertas empleo
              </router-link>
              <!-- --- -->
              <!-- OCULTAMOS DE MOMENTO EN PROD -->
              <!-- <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.nueva_oferta')" class="main">Nueva oferta
              </router-link> -->
              <!-- FORZAMOS A QUE VAYA A P.ESTUDIANTES EN PROD -->
              <span  :style="style.fontSecondary" class="main">Nueva oferta
              </span>
              <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/nueva-oferta/practicas" class="submenu">Nueva oferta estudiantes
              </router-link>
              <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/nueva-oferta/practicastitulados" class="submenu">Nueva oferta titulados
              </router-link>
              <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/nueva-oferta/empleo" class="submenu">Nueva oferta empleo
              </router-link>
              <!-- --- -->
  
              <template v-if="showPropuestaPracticas">
                <router-link @click.native="hideMenu" class="main" :style="style.fontSecondary" :to="$t('enlaces.propuesta_practicas')">Propuesta
                  de prácticas</router-link>
              </template>

              <template v-if="brand.canCambiarPracticas">
                <router-link @click.native="hideMenu" class="main" :style="style.fontSecondary" :to="$t('enlaces.solicitarcambiopracticas')">Solicitar cambio de prácticas</router-link>
              </template>
              <!-- OCULTAMOS DE MOMENTO EN PROD -->
              <!-- <template v-if="brand.hasProgramaPracticasActivo">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.programapracticasactivos')" class="main">Programas
                </router-link>
              </template> -->

              <span  :style="style.fontSecondary" class="main" :to="$t('enlaces.documentacion')">Documentación
              </span>
               <!-- OCULTAMOS DE MOMENTO EN PROD -->
              <router-link @click.native="hideMenu" :style="style.fontSecondary" class="submenu" :to="$t('enlaces.documentacion')+'/titulados'">Prácticas para titulados
              </router-link>
              <router-link @click.native="hideMenu" :style="style.fontSecondary" class="submenu" :to="$t('enlaces.documentacion')+'/estudiantes'">Prácticas para estudiantes
              </router-link>

              <template v-if="hasMenuEducacion && solicitudesEducacion.length != 0">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" class="main" :to="$t('enlaces.practicaseducacion')">Solicitudes prácticas educación
                </router-link>
              </template>

              <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/#encuestas" class="main">Encuestas
              </router-link>

              <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mi_empresa')" class="main">Mi empresa
              </router-link>

            </template>

            <template v-if="isEmpresa">

              <!-- <span  :style="style.fontSecondary" class="main">Prácticas estudiantes
                <button class="fa fa-angle-down" aria-hidden="true" @click="openPanelPracticasEstudiantes = !openPanelPracticasEstudiantes" :open="openPanelPracticasEstudiantes"></button>
              </span>
              <template v-if="openPanelPracticasEstudiantes">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/nueva-oferta/practicas" class="submenu">Nueva oferta
                </router-link>
                <router-link  v-if="showPropuestaPracticas" @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.propuesta_practicas')" class="submenu">Nueva propuesta de prácticas
                </router-link>
                <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/mis-ofertas/practicas" class="submenu">Mis ofertas
                </router-link>
                <router-link @click.native="hideMenu" :style="style.fontSecondary" class="submenu" :to="$t('enlaces.documentacion')+'/estudiantes'">Documentación
                </router-link>
              </template> -->

              <span :style="style.fontSecondary" class="main">Prácticas titulados
                <button class="fa fa-angle-down" aria-hidden="true" @click="openPanelPracticasTitulados = !openPanelPracticasTitulados" :open="openPanelPracticasTitulados"></button>
              </span>
              <template v-if="openPanelPracticasTitulados">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.programapracticasactivos')" class="submenu">Programas de prácticas
                </router-link>
                <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/nueva-oferta/practicastitulados" class="submenu">Nueva oferta
                </router-link>
                <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/mis-ofertas/practicastitulados" class="submenu">Mis ofertas
                </router-link>
                <router-link  v-if="showPropuestaPracticas" @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_propuestas_practicas')" class="submenu">Propuestas de prácticas
                </router-link>
                <router-link @click.native="hideMenu" :style="style.fontSecondary" class="submenu" :to="$t('enlaces.documentacion')+'/titulados'">Documentación
                </router-link>
              </template>

              <span :style="style.fontSecondary" class="main">Agencia empleo
                <button class="fa fa-angle-down" aria-hidden="true" @click="openPanelAgenciaEmpleo = !openPanelAgenciaEmpleo" :open="openPanelAgenciaEmpleo"></button>
              </span>
                <template v-if="openPanelAgenciaEmpleo">
                <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/nueva-oferta/empleo" class="submenu">Nueva oferta
                </router-link>
                <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/mis-ofertas/empleo" class="submenu">Mis ofertas
                </router-link>
              </template>
              
              <!-- <router-link @click.native="hideMenu" :style="style.fontSecondary" to="/#encuestas" class="main">Encuestas
              </router-link> -->

              <router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mi_empresa')" class="main">Mi empresa
              </router-link>

            </template>


            <router-link @click.native="hideMenu" class="logout" :style="style.fontSecondary" :to="$t('enlaces.ayuda')" v-if="brand.hashelp && isAlumno">Ayuda</router-link>

            <router-link @click.native="hideMenu" class="logout" :style="style.fontSecondary" :to="$t('enlaces.logout')">Cerrar sesión</router-link>
            <a v-if="brand.canBorrarCuenta & isAlumno" class="eraseAcount" :style="style.fontSecondary" @click="showpopupborrarcuenta = true">Solicitar baja</a>
          </div>

          <toggle-dark-mode v-if="islocalhost"></toggle-dark-mode>
          
        </nav>
        


      </div>

    </section>

    <popup-borrar-cuenta v-if="showpopupborrarcuenta" @hide="showpopupborrarcuenta = false"></popup-borrar-cuenta>

  </div>

</template>

<script lang="js">

  import { mapActions, mapGetters } from 'vuex';

  import Notificaciones from '@/components/parts/notificaciones'

  import popUpBorrarCuenta from '@/components/parts/popup-borrar-cuenta';
  import toggledarkmode from '@/components/parts/toggledarkmode';

  import router from '@/router';

  import Vue from 'vue'
  import Vue2TouchEvents from 'vue2-touch-events'

  Vue.use(Vue2TouchEvents)
  


  export default {
    name: 'app-header',
    data() {
      return {
        showMenu: false,
        nombre: '',
        showpopupborrarcuenta: false,
        openPanelEstudiante: false,
        openPanelTitulado: false,
        openPanelEmpleo:false,

        openPanelPracticasEstudiantes:false,
        openPanelPracticasTitulados:false,
        openPanelAgenciaEmpleo:false
      }
    },
    mounted() {

      var that = this;

      this.thingsOfHeader();

      $(window).scroll(function (event) {
        that.thingsOfHeader();
      });
      if (this.isEstudiante && this.isTitulado) {
        this.openPanelEstudiante = false
        this.openPanelTitulado = false
        this.openPanelEmpleo = false
      } else {
        this.openPanelEstudiante = true
        this.openPanelTitulado = true
        this.openPanelEmpleo = true
      }

    },
    methods: {
      ...mapActions(['logout', 'toggleDarkSide']),
      thingsOfHeader: function () {
        let distance = $(window).scrollTop();
        let when = ($(window).width() > 768) ? 70 : 70;
        (distance >= when) ? $(".header").addClass('min') : $(".header").removeClass('min');
      },
      hideMenu: function () {
        this.showMenu = false;
      },
      showDisponible: function () {
        alert('Muy pronto disponible')
      }
    },
    computed: {
      ...mapGetters({
        isAlumno: 'isAlumno',
        isEstudiante: 'isEstudiante',
        isTitulado: 'isTitulado',
        isEmpresa: 'isEmpresa',
        style: 'getStyles',
        colors: 'basicColors',
        logo: 'getLogo',
        logocolor: 'getLogoColor',
        logoencabezado: 'getLogoEncabezado',
        logosize: 'getLogoSize',
        personales: 'getUserName',
        logged: 'getLogged',
        ofertasParams: 'getParamsOfertas',
        darkmode: 'getDarkSide',
        hasPracticas: 'hasPracticas',
        getShowPropuestaPracticas: 'getShowPropuestaPracticas',
        version: 'getVersion',
        brand : 'getBrand',
        inproduction : 'getInProduction',
        hasMenuEducacion : 'getMenuEducacion',
        solicitudesEducacion : 'getsolicitudesEducacion'
      }),
      isMin: function () {
        let allow = [
          'ficha_oferta_alumno_empleo',
          'ficha_oferta_alumno_practicas',
          'ficha_oferta_alumno_practicas_titulados',
          'ficha_oferta_empresa',
          'ficha_encuestas',
          'visor_oferta',
          'ficha-solicitudes-educacion',
          'ficha_oferta_alumno_practicas-candidaturas'
        ];
        return (allow.some(el => this.$route.name == el));
      },
      ownstyles: function () {
        return {
          colorNombre: {
            color: (!!this.colors.fontAlternative) ? this.colors.fontAlternative : this.colors.white
          },
          colorMenu: {
            color: (!!this.colors.fontAlternative) ? this.colors.fontAlternative : this.colors.white
          }
        }
      },
      logoselected() {
        let logo = (!!this.logoencabezado) ? this.logoencabezado : this.logo;

        if(this.darkmode){
          logo = this.brand.logodarkmode;
        }

        return logo;
      },
      showPropuestaPracticas() {
        let show;
        
        if(typeof this.getShowPropuestaPracticas == 'string'){
          show = (this[this.getShowPropuestaPracticas]);
        }else{
          show = this.getShowPropuestaPracticas
        }

        return show;
      },
      islocalhost(){
        return (window.location.hostname == 'localhost');
      }
    },
    components: {
      'notificaciones': Notificaciones,
      'popup-borrar-cuenta' : popUpBorrarCuenta,
      'toggle-dark-mode' : toggledarkmode
    },
    watch: {
      '$route': function () {
        this.showMenu = false;
        if (this.isEstudiante && this.isTitulado) {
        this.openPanelEstudiante = false
        this.openPanelTitulado = false
        this.openPanelEmpleo = false
      } else {
        this.openPanelEstudiante = true
        this.openPanelTitulado = true
        this.openPanelEmpleo = true
      }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/colors.scss";

</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue